module.exports = __webpack_public_path__ + "img/winnipeg_jets_logo.cdae9c6d.jpg";